import { DISPATCH_METHODS } from '~constants/orders';
import { sortByStatus } from '~model/order';

export const orderMapper = (items, filters) =>
  items.sort(sortByStatus(filters)).map((item) => ({
    ...item,
    dispatchMethod: DISPATCH_METHODS[item.dispatchMethod]
  }));

export const mapToIds = (orders) => orders?.map(({ id }) => id);
